"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DualRing = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function DualRing({ color = '#7f58af', size = 80, className, style, ...rest }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-dual-ring'], className), style: { width: size, height: size, ...style }, ...rest, children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-dual-ring-after']), style: {
                borderColor: `${color} transparent`,
                borderWidth: size * 0.1,
                width: size * 0.7 - 6,
                height: size * 0.7 - 6,
            } }) }));
}
exports.DualRing = DualRing;
//# sourceMappingURL=dual-ring.js.map